import React from "react";
import { MANIFESTO } from "@/data/siteContent";

export default function Manifesto({ settings, language }) {
  return (
    <section className="manifesto-section" id="manifesto" data-testid="manifesto-section">
      <div className="section-shell">
        <div className="section-header reveal">
          <span className="section-label">{language === "en" ? "01 // How we work" : "01 // Cómo trabajamos"}</span>
          <div>
            <h2 className="section-title">{language === "en" ? "The system is the service." : "El sistema es el servicio."}</h2>
            <p className="section-intro">{language === "en" ? "Comfort is not a single part. It is the quiet result of good decisions, careful work, and a team that stays accountable." : "El confort no es una sola pieza. Es el resultado silencioso de buenas decisiones, trabajo cuidadoso y un equipo responsable."}</p>
          </div>
        </div>
        <div className="manifesto-grid">
          {MANIFESTO.map((chapter, index) => {
            return (
              <article className="chapter-card reveal" key={chapter.number} data-testid={`manifesto-chapter-${chapter.number}`} style={{ transitionDelay: `${index * 80}ms` }}>
                <div className="chapter-card-top"><span className="chapter-index">{chapter.number}</span><span className="chapter-code">{chapter.code}</span></div>
                <h3 className="chapter-title">{chapter.title[language]}</h3>
                <p className="chapter-description">{chapter.description[language]}</p>
                <div className="chapter-metric"><span className="metric-label">{chapter.metricLabel[language]}</span><strong className="metric-value">{chapter.metricValue[language]}</strong></div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
